import { FC } from 'react';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

type Props = {
  bottomText?: string;
};

export const EmptyTable: FC<Props> = ({ bottomText }) => {
  return (
    <Grid container flexDirection="column" textAlign="center" sx={{ p: 10 }}>
      <Typography color="primary">
        <FindInPageIcon sx={{ fontSize: 100 }} color="primary" />
      </Typography>
      <Typography color="primary">{bottomText}</Typography>
    </Grid>
  );
};
